import { ExperienceResource } from '../../Types';
import LearningDesignExperienceStore from './Store';

export const experienceStore = (
  experienceResource: ExperienceResource,
): LearningDesignExperienceStore => {
  return new LearningDesignExperienceStore(experienceResource);
};

export const experienceStoreWithSelectedIds = (
  experienceResource: ExperienceResource,
  selectedIds: number[],
): LearningDesignExperienceStore => {
  const s = experienceStore(experienceResource);
  s.setSelectedIds(selectedIds);
  return s;
};
